// extracted by mini-css-extract-plugin
export var header__illustration = "about-module--header__illustration--fNhGQ";
export var portrait__container = "about-module--portrait__container--1pjaK";
export var social__button = "about-module--social__button--1ce7W";